import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const kandji = defineConnector({
  identifier: "kandji",
  name: "Kandji",
  tagLine: "Apple device management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://.*\\.api\\.kandji\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your Kandji tenant and navigate to **Settings > Access > API** to create an API token.",
        },
      ],
    },
    {
      title: "Enter your Kandji details",
      items: [
        {
          kind: "hostname",
          label: "Kandji domain",
          required: true,
          placeholder: "yourcompany",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Your Kandji domain (e.g., 'yourcompany' from yourcompany.api.kandji.io).",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/devices`,
  },
  publicEnvVars: ({ domain }) => ({
    KANDJI_URL: domain ? `https://${domain}` : "",
  }),
});
